<template>
  <a href="#" data-action="open-radioplayer" data-position="menu" @click.prevent="openChannel(openDefaultChannel === 'true' ? defaultChannel : channel.id)" class="c-menu__meta-button [ c-button c-button--base c-button--large ]">
    <div v-if="activeChannel && buffering" class="loading o-icon"></div>
    <img class="o-icon c-player__icon" v-else-if="activeChannel" src="./images/ic_bars.svg" alt="Playing" />
    <SvgIcon v-else icon="play" class="c-menu__meta-icon" />
    Luister Live
  </a>
</template>

<script>
import { mapState } from 'vuex';
import { openPlayer } from '../../mixins/radioPlayer';

export default {
  name: 'PlayButton',
  mixins: [openPlayer],
  props: [
    'openDefaultChannel', // Use `data-component="PlayButton" data-open-default-channel="true"` to allway open the default channel
  ],
  computed: {
    ...mapState({
      channels: state => state.channels.channels,
      activeChannel: state => state.radioplayer.activeChannel || false,
      defaultChannel: state => state.stations.stationId,
      buffering: state => state.radioplayer.buffering,
      channel: (state) => {
        const { activeChannel, lastChannel } = state.radioplayer;
        const channelId = activeChannel || lastChannel || state.stations.stationId;
        return  state.channels.channels.filter(channel => channel.id === channelId).pop() || {};
      },
    }),
  },
}
</script>
